import { useEffect } from "react";
import { useUserDetails } from "./context/auth";
import Signin from "./pages/authentication/signin";
import HRDashboard from "./pages/dashboard/HR_dashboard";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import EmployeeManagement from "./pages/employeemanagement";
import AddEmployee from "./pages/employeemanagement/components/AddEmployee";
import AddManager from "./pages/managermanagement/Components/AddManager";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AddLeaveRequest from "./pages/leavemanagement/components/AddLeaveRequest";
import LeaveManagement from "./pages/leavemanagement";
import RegularizationRequest from "./pages/regularizationrequest";
import AddRegularization from "./pages/regularizationrequest/components/AddRegularization";
import AddWFH from "./pages/wfhmanagement/components/AddWFH";
import Attendance from "./pages/attendance";
import Callender from "./pages/callender";
import HRCalendar from "./pages/callender/HRCalendar";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ComponentManagement from "./pages/mastercomponent";
import AddSalaryStructure from "./pages/salarystructure/components/AddSalaryStructure";
import SalaryStructure from "./pages/salarystructure";
import AddComponent from "./pages/mastercomponent/components/AddComponent";
import AddWeekOff from "./pages/weekoff/components";
import EmployeeSalary from "./pages/employeesalary";
import AddEmployeeSalary from "./pages/employeesalary/components/AddSalaryStructure";
import Holiday from "./pages/holiday";
import AddHoliday from "./pages/holiday/components/AddHoliday";
import AddPayroll from "./pages/payroll/components/AddSalaryStructure";
import AddPerformance from "./pages/performance/components/AddPerformance";
import Shift from "./pages/shift";
import AddShift from "./pages/shift/components/AddShift";
import ViewScreen from "./pages/employeemanagement/components/AddEmployee/components/ViewScreen";
import Shift_viewscreen from "./pages/shift/Viewscreen";
import ShiftRoster from "./pages/shift/components/ShiftRoster";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import AddOT from "./pages/OT_Master/Component";
import OTConfiguration from "./pages/OTConfiguration";
import LeaveConfiguration from "./pages/LeaveConfiguration/LeaveConfiguration";
import Addleaveconfiguration from "./pages/LeaveConfiguration/LeaveConfiguration/Component";
import LatePolicyConfiguration from "./pages/LatePolicyConfiguration";
import AddLatePolicyConfiguration from "./pages/LatePolicyConfiguration/Component";
import ShiftPaisaConfiguration from "./pages/ShiftPaisaConfiguration";
import AddShiftPaisaConfiguration from "./pages/ShiftPaisaConfiguration/Component";
import MissingPunches from "./pages/MissingPunches";
import ViewScreen_LeaveData from "./pages/leavemanagement/ViewScreen";
import Role_Permit from "./pages/Role_Permission";
import Rollcreation from "./pages/Rolecreate/component";
import Rolecreatelist from "./pages/Rolecreate";
import RegularzationApproval from "./pages/regularizationrequest/ViewScreen";
import WFHApproval from "./pages/wfhmanagement/ViewScreen";
import WFHViewScreen from "./pages/wfhmanagement/ViewScreen/View_index";
import ViewScreenRegularzation from "./pages/regularizationrequest/ViewScreen/Regularzise_View";
import LeaveApproval from "./pages/leavemanagement/ViewScreen/LeaveApproval";
import AddPayslip from "./pages/Payslip";
import Newstaff from "./newonboardfolder/createStaffrequesst2";
import SourceProfile from "./newonboardfolder/sourceprofile";
import Screening from "./newonboardfolder/screening";
import Sourcing from "./newonboardfolder/Sourcing";
import ApprovalScreen from "./newonboardfolder/ApprovalScreen";
import Permission from "./pages/Permission";
import PermissionApproval from "./pages/PermissionApproval";
import Permissiontable from "./pages/Permissiontable";
import PerfomanceEvaluationForm from "./pages/performanceEvaluation/PerfomanceEvaluationForm";
import { Company } from "./pages/company/Company";
import BranchMaster from "./pages/branch";
import AddBranch from "./pages/branch/AddBranch";
import CategoryMaster from "./pages/category";
import AddCategory from "./pages/category/AddCategory";
import CategoryIcon from "@mui/icons-material/Category";
import DeviceList from "./pages/device";
import AddDevice from "./pages/device/AddDevice";
import DevicesIcon from "@mui/icons-material/Devices";
import NewAttendance from "./pages/attendance/component/NewAttendance";
import {
  AddCard,
  CurrencyRupee,
  Redeem,
  TrendingUp,
} from "@mui/icons-material";
import SalaryAdvance from "./pages/salaryadvance/component";
import TableSalaryAdvance from "./pages/salaryadvance";
import Bonus from "./pages/bonus/Bonus";
import AddBonus from "./pages/bonus/components/AddBonus";
import Report from "./pages/report/Report";
import Increment from "./pages/increment/IncrementReport";
import IncrementData from "./pages/increment/components/IncrementData";
import Payroll from "./pages/payroll";
import SalarySlip from "./pages/Payslip/EmfPayslip";
import SalaryReport from "./pages/report/components/SalaryReport";
import AdvanceReport from "./pages/report/components/AdvanceReport";
import PfReport from "./pages/report/components/PfReport";
import EsiReport from "./pages/report/components/EsiReport";
import BonusReport from "./pages/report/components/BonusReport";

function Routes_Data() {
  const { setroutesdata, AccessData } = useUserDetails();

  // Branch-level access control
  const _rawUser = JSON.parse(sessionStorage.getItem("user") || "{}");
  const _userData = Array.isArray(_rawUser) ? _rawUser[0] : _rawUser;
  const _isBranchAdmin = _userData?.is_branch_admin || false;

  const routes = [
    {
      name: "Authentication",
      key: "authentication",
      collapse: [
        {
          name: "Sign in",
          key: "sign-in",
          route: "/sign-in",
          component: <Signin />,
        },
      ],
    },

    {
      type: "collapse",
      icon: <HomeIcon />,
      name: "DashBoard",
      key: "dashboard",
      route: "/dashboard",
      component: <HRDashboard />,
      noCollapse: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    ...(!_isBranchAdmin ? [{
      type: "collapse",
      icon: <AccountTreeIcon />,

      name: "Branch",
      key: "branch",
      route: "/branch",
      component: <BranchMaster />,
      noCollapse: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "collapse",
      icon: <CategoryIcon />,
      name: "Category Master",
      key: "category",
      route: "/category",
      component: <CategoryMaster />,
      noCollapse: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "collapse",
      icon: <DevicesIcon />,
      name: "Device Management",
      key: "device",
      route: "/device",
      component: <DeviceList />,
      noCollapse: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "collapse",
      icon: <AddBusinessIcon />,
      name: "Company Master",
      key: "company",
      route: "/company",
      component: <Company />,
      noCollapse: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    }] : []),
    {
      type: "collapse",
      name: "Master",
      key: "admin",
      icon: <ManageAccountsIcon size="12px" />,
      collapse: [
        {
          name: "Employee Management",
          key: "employee-management",
          route: "/employee-management",
          component: <EmployeeManagement />,
        },
        {
          name: "Report",
          key: "report",
          route: "/report",
          component: <Report />,
        },
      ],
    },

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Leave Configuration" ||
        item.module === "OTMaster" ||
        item.module === "ApplyLeave" ||
        item.module === "RegularaizationRequest" ||
        item.module === "WFHManagement" ||
        item.module === "WeekOff" ||
        item.module === "Holiday"
    )
      ? [
          {
            type: "collapse",
            name: "Leave Management",
            key: "leave-management",
            icon: <CalendarMonthIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "LeaveConfiguration" && item.can_access
              )
                ? [
                    {
                      name: "Leave Configuration",
                      key: "leave-configuration",
                      route: "/leave-configuration",
                      component: <LeaveConfiguration />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Holiday" && item.can_access
              )
                ? [
                    {
                      name: "Holiday",
                      key: "holiday",
                      route: "/holiday",
                      component: <Holiday />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Weekoff" && item.can_access
              )
                ? [
                    {
                      name: "Weekoff",
                      key: "weekoff",
                      route: "/weekOff",
                      component: <AddWeekOff />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "ApplyLeave" && item.can_access
              )
                ? [
                    {
                      name: "Leave Request",
                      key: "leave-request",
                      route: "/leave-management",
                      component: <LeaveManagement />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "OTMaster" && item.can_access
              )
                ? [
                    {
                      name: "Permission",
                      key: "permission-list",
                      route: "/permission-list",
                      component: <Permissiontable />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    // ── Shift Management ──
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Shift Management" && item.can_access
    )
      ? [
          {
            type: "collapse",
            name: "Shift Management",
            key: "shift-management",
            icon: <ScheduleIcon size="12px" />,
            collapse: [
              ...(!_isBranchAdmin ? [{
                name: "Shift",
                key: "shift",
                route: "/shift",
                component: <Shift />,
              }] : []),
              {
                name: "Shift Roster",
                key: "shift-roster-nav",
                route: "/shift/shift-roster",
                component: <ShiftRoster />,
              },
              ...(!_isBranchAdmin ? [
              {
                name: "Shift Paisa",
                key: "shift-paisa-configuration",
                route: "/shift-paisa-configuration",
                component: <ShiftPaisaConfiguration />,
              },
              {
                name: "Late Policy",
                key: "late-policy-configuration",
                route: "/late-policy-configuration",
                component: <LatePolicyConfiguration />,
              },
              {
                name: "OT Configuration",
                key: "ot-configuration",
                route: "/ot-configuration",
                component: <OTConfiguration />,
              }] : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Payroll" && item.can_access
    )
      ? [
          {
            type: "collapse",
            icon: <CurrencyRupee />,
            name: "Payroll List",
            key: "payroll",
            route: "/payroll",
            component: <Payroll />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),
    {
      name: "collapse",
      key: "add-payroll",
      route: "/payroll/add-payroll",
      component: <AddPayroll />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "payslip",
      route: "/payroll/payslip",
      component: <SalarySlip />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      name: "add-branch",
      key: "add-branch",
      route: "/branch/add-branch",
      component: <AddBranch />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      name: "add-category",
      key: "add-category",
      route: "/category/add-category",
      component: <AddCategory />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      name: "add-device",
      key: "add-device",
      route: "/device/add-device",
      component: <AddDevice />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "SalaryAdvance" && item.can_access
    )
      ? [
          {
            type: "collapse",
            icon: <AddCard />,
            name: "Salary Advance",
            key: "salary-advance",
            route: "/salary-advance",
            component: <TableSalaryAdvance />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Increment" && item.can_access
    )
      ? [
          {
            type: "collapse",
            icon: <TrendingUp />,
            name: "Increment",
            key: "increment",
            route: "/increment",
            component: <Increment />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),
    {
      type: "noCollapse",
      name: "increment-data",
      key: "increment-data",
      route: "/increment/increment-data",
      component: <IncrementData />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Bonus" && item.can_access
    )
      ? [
          {
            type: "collapse",
            icon: <Redeem />,
            name: "Bonus",
            key: "bonus",
            route: "/bonus",
            component: <Bonus />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),
    {
      type: "noCollapse",
      name: "add-bonus",
      key: "add-bonus",
      route: "/bonus/add-bonus",
      component: <AddBonus />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      name: "Add Advance",
      key: "add-advance",
      route: "/salary-advance/add-advance",
      component: <SalaryAdvance />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "Salary-report",
      key: "salary-report",
      route: "/report/salary-report",
      component: <SalaryReport />,
    },
    {
      name: "Advance-report",
      key: "advance-report",
      route: "/report/advance-report",
      component: <AdvanceReport />,
    },
    {
      name: "pf-report",
      key: "pf-report",
      route: "/report/pf-report",
      component: <PfReport />,
    },
    {
      name: "esi-report",
      key: "esi-report",
      route: "/report/esi-report",
      component: <EsiReport />,
    },
    {
      name: "bonus-report",
      key: "bonus-report",
      route: "/report/bonus-report",
      component: <BonusReport />,
    },

    {
      type: "noCollapse",
      key: "onboarding-staff-request",
      route: "/staff-request/create-Staffrequest",
      component: <Newstaff />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "onboarding-approval-screen",
      route: "/staff-request/approval-screen",
      component: <ApprovalScreen />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "sourcing",
      route: "/sourcing/create-Sourcing",
      component: <Sourcing />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "screening",
      route: "/sourcing/createscreening",
      component: <Screening />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "feedback",
      route: "/technical/feedback",
      component: <SourceProfile />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "add-employee-form",
      route: "/employee-management/add-employee",
      component: <AddEmployee />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-employee-viewscreen",
      route: "/employee-management/viewscreen",
      component: <ViewScreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-employee-leave-viewscreen",
      route: "/leave-management/viewscreen",
      component: <ViewScreen_LeaveData />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "employee-details",
      route: "/employee-management/employee-details",
      component: <AddEmployee />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "add-manager",
      route: "/manager-management/add-manager",
      component: <AddManager />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "manager-details",
      route: "/manager-management/manager-details",
      // route: "/manager-management/manager-details/:id",
      component: <AddManager />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "AddComponent",
      key: "add-component",
      route: "/component/add-component",
      component: <AddComponent />,
      protected: true,
    },
    {
      type: "salaryStructure",
      key: "salary-structure",
      route: "/salary-structure/add-salary-structure",
      component: <AddSalaryStructure />,
      protected: true,
    },
    {
      type: "employeeSalary",
      key: "employee-salary",
      route: "/employee-salary/add-employee-salary",
      component: <AddEmployeeSalary />,
      protected: true,
    },
    ...(!_isBranchAdmin && AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Role" || item.module === "Role Permission"
    )
      ? [
          {
            type: "collapse",
            name: "Identity",
            key: "identity",
            icon: <SupervisorAccountIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Role" && item.can_access
              )
                ? [
                    {
                      name: "Role Creation",
                      key: "rollcreation",
                      route: "/rollcreationlist",
                      component: <Rolecreatelist />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Role Permission" && item.can_access
              )
                ? [
                    {
                      name: "Role Permission",
                      key: "rolepermission",
                      route: "/rolepermission",
                      component: <Role_Permit />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        (item.module === "Attendance" && item.can_access) ||
        (item.module === "Calendar" && item.can_access) ||
        (item.module === "RegularaizationRequest" && item.can_access)
    )
      ? [
          {
            type: "collapse",
            name: "Calendar",
            key: "calendar",
            icon: <EditCalendarIcon size="12px" />,
            collapse: [
              ...(!_isBranchAdmin && AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "RegularaizationRequest" && item.can_access
              )
                ? [
                    {
                      name: "Regularization Request",
                      key: "regularization-request",
                      route: "/regularization-request",
                      component: <RegularizationRequest />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Attendance" && item.can_access
              )
                ? [
                    {
                      name: "Attendance",
                      key: "attendance",
                      route: "/attendance",
                      component: <Attendance />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Calendar" && item.can_access
              )
                ? [
                    {
                      name: "Calendar",
                      key: "Calendar",
                      route: "/calendar",
                      component: <Callender />,
                    },
                    {
                      name: "HR Calendar",
                      key: "hr-calendar",
                      route: "/hr-calendar",
                      component: <HRCalendar />,
                    },
                  ]
                : []),
              {
                name: "Missing Punches",
                key: "missing-punches",
                route: "/missing-punches",
                component: <MissingPunches />,
              },
            ],
          },
          {
            name: "Attendance",
            key: "attendanceTable",
            route: "/attendanceTable",
            component: <NewAttendance />,
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Component" ||
        item.module === "EmployeeSalery" ||
        item.module === "SaleryStructure" ||
        item.module === "Payroll" ||
        item.module === "Payslip"
    )
      ? [
          {
            type: "collapse",
            name: "Pay Roll",
            key: "pay-roll",
            icon: <AccountBalanceWalletIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Component" && item.can_access
              )
                ? [
                    {
                      name: "Component",
                      key: "component",
                      route: "/component",
                      component: <ComponentManagement />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "SaleryStructure" && item.can_access
              )
                ? [
                    {
                      name: "Salary Structure",
                      key: "salary-structure",
                      route: "/salary-structure",
                      component: <SalaryStructure />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "EmployeeSalery" && item.can_access
              )
                ? [
                    {
                      name: "Employee Salary",
                      key: "employee-salary",
                      route: "/employee-salary",
                      component: <EmployeeSalary />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Payroll" && item.can_access
              )
                ? [
                    {
                      name: "Pay Roll",
                      key: "pay-roll",
                      route: "/add-pay-roll",
                      component: <AddPayroll />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Payslip" && item.can_access
              )
                ? [
                    {
                      name: "PaySlip",
                      key: "pay-slip",
                      route: "/pay-slip",
                      component: <AddPayslip />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      name: "collapse",
      key: "add-OT",
      route: "/OTMaster/add-OT",
      component: <AddOT />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "onboarding-permission-request",
      route: "/permission/requestpermission",
      component: <Permission />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-leaveconfiguration",
      route: "/leave-configuration/add-leaveconfiguration",
      component: <Addleaveconfiguration />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-late-policy-configuration",
      route: "/late-policy-configuration/add",
      component: <AddLatePolicyConfiguration />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-shift-paisa-configuration",
      route: "/shift-paisa-configuration/add",
      component: <AddShiftPaisaConfiguration />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "collapse",
      key: "add-leaverequest-form",
      route: "/leave-management/add-leaverequest",
      component: <AddLeaveRequest />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-leaverequest-approval",
      route: "/leave-management/leaveapproval",
      component: <LeaveApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      name: "AddRegularization",
      key: "add-regularization",
      route: "/regularization-request/add-regularization",
      component: <AddRegularization />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "regularization-details-edit",
      route: "/regularization-request/regularization-details",
      component: <AddRegularization />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "regularization-details-approval",
      route: "/regularization-request/RegularzationApproval",
      component: <RegularzationApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "regularization-details-view",
      route: "/regularization-request/ViewRegularzation",
      component: <ViewScreenRegularzation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "noCollapse",
      key: "add-wfh",
      route: "/WFH-Management/add-WFH",
      component: <AddWFH />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details-edit",
      route: "/WFH-Management/WFH-details",
      component: <AddWFH />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details-approval",
      route: "/WFH-Management/WFHApproval",
      component: <WFHApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details-view",
      route: "/WFH-Management/WFHViewScreen",
      component: <WFHViewScreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "weekoff-details",
      route: "/weekoff/weekoff-details",
      component: <AddWeekOff />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "noCollapse",
      key: "add-shift",
      route: "/shift/add-shift",
      component: <AddShift />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "shift-details-edit",
      route: "/shift/shift-details",
      component: <AddShift />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "shift-details-viewscreen",
      route: "/shift/Viewscreen",
      component: <Shift_viewscreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "shift-roster",
      route: "/shift/shift-roster",
      component: <ShiftRoster />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "noCollapse",
      key: "add-holiday",
      route: "/holiday/add-holiday",
      component: <AddHoliday />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "holiday-details",
      route: "/holiday/holiday-details",
      component: <AddHoliday />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "noCollapse",
      key: "rollcreation",
      route: "/rollcreationlist/rollcreation",
      component: <Rollcreation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "noCollapse",
      key: "add-performance",
      route: "/performance/add-performance",
      component: <AddPerformance />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "performance-details",
      route: "/performance/performance-details",
      component: <AddPerformance />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "onboarding-permission-request-view",
      route: "/permission/requestpermission",
      component: <Permission />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "onboarding-permission-approve",
      route: "/permission/approve",
      component: <PermissionApproval />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "performance-evaluation-details",
      route: "/performance-evaluation/performance-evaluation-details",
      component: <PerfomanceEvaluationForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
  ];

  const demofunction = () => {
    setroutesdata(routes);
  };

  useEffect(() => {
    if (AccessData) {
      setroutesdata(routes);
    }
  }, [AccessData, setroutesdata]);
  return <div></div>;
}

export default Routes_Data;
